import React from "react";
import { Button } from "@mui/material";
import { Email } from "@mui/icons-material";
import { SendReminderButtonProps } from "./types";
import { useSendReminder } from "./useSendReminder";
import { SendReminderModal } from "../sendReminderModal/SendReminderModal";

export const SendReminderButton = ({
  collectorIds,
  fromDate,
  toDate,
  totalSelectedRows,
  selectedRowsData,
}: SendReminderButtonProps) => {
  const {
    isModalOpen,
    isLoadingFormData,
    isSending,
    dataProviders,
    recipients,
    defaultSubject,
    defaultMessage,
    collectors,
    platformUsers,
    openModal,
    closeModal,
    handleDataProviderRemove,
    handleSend,
    handleRecipientsChange,
  } = useSendReminder({ collectorIds, fromDate, toDate, selectedRowsData });

  return (
    <>
      <Button
        startIcon={<Email />}
        variant="contained"
        sx={{ borderRadius: "8px", width: 'fit-content' }}
        disabled={totalSelectedRows === 0}
        onClick={openModal}
      >
        Send Reminder
      </Button>
      {isModalOpen && (
        <SendReminderModal
          isLoadingFormData={isLoadingFormData}
          isSending={isSending}
          dataProviders={dataProviders}
          recipients={recipients}
          defaultSubject={defaultSubject}
          defaultMessage={defaultMessage}
          collectors={collectors}
          platformUsers={platformUsers}
          onClose={closeModal}
          onSend={handleSend}
          onDataProviderRemove={handleDataProviderRemove}
          onRecipientsChange={handleRecipientsChange}
        />
      )}
    </>
  );
};
